export default class SvgCircleElement extends HTMLElement {

    static get observedAttributes() { return ['value']; }

    constructor() {
        super();
    }

    connectedCallback() {

        let value = parseInt(this.getAttribute('value'));

        this.innerHTML = generateSVGCircle(value);

        if (value < 50) {
            this.classList.add('fail');
        } else if (value < 90) {
            this.classList.add('average');
        } else {
            this.classList.add('pass');
        }

    }
}

function generateSVGCircle(percent) {
    return `
        <span>${parseInt(percent)}</span>
      <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="40" fill="none" stroke="black" stroke-width="10" 
                stroke-dasharray="${(Math.PI * 2 * 40 * percent) / 100} ${Math.PI * 2 * 40}" />
      </svg>
    `;
}

window.customElements.define('svg-circle', SvgCircleElement);
